import { useCallback, useEffect, useRef } from 'react';

import { useManagedTimeout } from 'design-system';
import { useEvent } from 'react-use';

import { useChartContext } from '@/features/charts/context/ChartContext';
import type { ExtendedSeriesOptionsType } from '@/features/charts/types/highcharts';

const useRegularChart = ({
  chartSeries
}: {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
}) => {
  const chartContainerRef = useRef<HTMLDivElement>(null);
  const { schedule: scheduleResize } = useManagedTimeout();

  const { setChartSeries, chartRef } = useChartContext();

  const handleResize = useCallback(() => {
    const chart = chartRef.current?.chart;
    const container = chartContainerRef.current;

    if (!chart || !container) return;

    scheduleResize(() => {
      chart.container.style.display = 'none';
      chart.setSize(container.getBoundingClientRect().width);
      chart.container.style.display = 'block';
    }, 100);
  }, [chartRef, scheduleResize]);

  useEvent('resize', handleResize, window);

  useEffect(() => {
    setChartSeries(chartSeries);
  }, [chartSeries, setChartSeries]);

  return { chartContainerRef };
};

export default useRegularChart;
